import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { NgxPermissionsService } from 'ngx-permissions';
import { NetworkService } from 'src/app/core/services/network.service';
import { map, catchError } from 'rxjs/operators';
import { ROLES } from 'src/app/shared/roleList/priorityRoleList';
import { DataService } from 'src/app/shared/services/data.service';
import { MsalService } from '@azure/msal-angular';

@Injectable({
    providedIn: 'root'
})
export class PermissionGuard {
    roles: any[] = ROLES;
    constructor(
        private permissionsService: NgxPermissionsService,
        private http: NetworkService,
        private dataSer: DataService,
        private msalService: MsalService,
        private router: Router) {
    }

    private getRoleFromTokenClaims(): string {
        const activeAccount = this.msalService.instance.getActiveAccount() || this.msalService.instance.getAllAccounts()?.[0];
        const profile = activeAccount?.idTokenClaims?.roles ? activeAccount.idTokenClaims.roles : [];
        const priorityRoles = this.dataSer.rolePrioritySetter(profile);

        if (priorityRoles && priorityRoles.length) {
            return priorityRoles[0];
        }

        if (profile && profile.length) {
            return profile[0].toString().toLowerCase().split(' ').join('-');
        }

        return 'no-role';
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        // Check if user has an active account
        const activeAccount = this.msalService.instance.getActiveAccount() || this.msalService.instance.getAllAccounts()?.[0];

        // If no account, user is not authenticated - block access
        // app.component monitors account loss and will redirect to login
        if (!activeAccount) {
            return false;  // Block route - app.component will detect and redirect
        }

        // User is authenticated, load their permissions
        const role = this.getRoleFromTokenClaims();
        localStorage.setItem('userRole', role);

        return this.http.getPermissions(role).pipe(
            map((permission) => {
                const permissionsList = Array.isArray(permission) ? permission : [];
                this.permissionsService.loadPermissions(permissionsList);
                return true;
            }),
            catchError((err) => {
                this.permissionsService.flushPermissions();
                this.permissionsService.loadPermissions([]);
                return of(true);
            })
        );
    }
}
